import { GamePriceType } from '@/helpers/calculateGamePrice';

export default function numberToCurrency(
  price: GamePriceType,
  currency: string = '€',
  nbsp: boolean = false
): string {
  currency = currency === '€' || currency === 'EUR' ? 'EUR' : 'DEM';

  const result =
    price === null
      ? '--,--'
      : new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: currency,
        })
          .format(price)
          .replace('DEM', 'DM');
  // ensure the amount and currency symbol never wrap onto separate lines
  return nbsp ? result.replace(' ', ' ') : result;
}

export function numberToLocaleString(number: any, suffix?: string): string {
  const output =
    number instanceof Number
      ? number.toLocaleString('de-DE')
      : new Intl.NumberFormat('de-DE', {}).format(number);
  return suffix ? `${output} ${suffix}` : output;
}
